import React, { useState } from 'react';
import axios from 'axios';
import SidebarLayout from '../../components/SidebarLayout';
import styles from './ReportIssuePage.module.css';
import { useToast } from '../../contexts/ToastContext';
import { API_BASE_URL as API_URL } from '../../config/apiBase';



const ISSUE_TYPES = ['Login Error', 'Bug', 'Feature Request', 'Other'];

const ReportIssuePage = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    issueType: 'Bug',
    issueTypeOther: '',
    description: ''
  });
  const [screenshot, setScreenshot] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { showSuccess, showError } = useToast();
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    setScreenshot(file || null);
  };

  const validate = () => {
    if (!form.name.trim()) return 'Name is required';
    if (!form.subject.trim()) return 'Subject is required';
    if (!form.description.trim()) return 'Description is required';
    if (!form.issueType) return 'Issue type is required';
    if (form.issueType === 'Other' && !form.issueTypeOther.trim()) return 'Please specify issue type';
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return 'Invalid email format';
    return null;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    const validation = validate();
    if (validation) {
      showError(validation);
      return;
    }

    try {
      setSubmitting(true);
      const data = new FormData();
      
      data.append('name', form.name);
      if (form.email) data.append('email', form.email);
      data.append('subject', form.subject);
      data.append('issueType', form.issueType);
      if (form.issueType === 'Other' && form.issueTypeOther) data.append('issueTypeOther', form.issueTypeOther);
      data.append('description', form.description);
      if (screenshot) data.append('screenshot', screenshot);

      const res = await axios.post(`${API_URL}/server/report-issue`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data?.success) {
        showSuccess('Thank you! Your issue has been submitted.');
        setForm({ name: '', email: '', subject: '', issueType: 'Bug', issueTypeOther: '', description: '' });
        setScreenshot(null);
      } else {
        showError(res.data?.message || 'Submission failed');
      }
    } catch (err) {
      showError(err.response?.data?.message || err.message || 'Submission failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <SidebarLayout>
      <div className={styles.container}>
      <div className={styles.card}>
        {/* <button
          className={styles.backButton}
          type="button"
          onClick={() => window.location.href = '/dashboard'}
          style={{
            marginBottom: 18,
            background: 'linear-gradient(90deg, #6366f1 0%, #22d3ee 100%)',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            padding: '8px 22px',
            cursor: 'pointer',
            fontWeight: 500,
            fontSize: 16,
            boxShadow: '0 2px 8px rgba(99,102,241,0.08)',
            transition: 'background 0.2s'
          }}
        >
          ← Back to Dashboard
        </button> */}
        <h1 className={styles.title}>Report an Issue</h1>
        <p className={styles.subtitle}>Tell us what went wrong and we’ll look into it.</p>

        {message && <div className={styles.success}>{message}</div>}
        {error && <div className={styles.error}>{error}</div>}

        <form onSubmit={onSubmit} className={styles.form}>
          <div className={styles.row}>
            <div className={styles.field}>
              <label>Name<span className={styles.required}>*</span></label>
              <input name="name" value={form.name} onChange={onChange} placeholder="Your name" />
            </div>
            <div className={styles.field}>
              <label>Email</label>
              <input name="email" value={form.email} onChange={onChange} placeholder="you@example.com" />
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.field}>
              <label>Issue Type<span className={styles.required}>*</span></label>
              <select name="issueType" value={form.issueType} onChange={onChange}>
                {ISSUE_TYPES.map(t => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
            </div>
            {form.issueType === 'Other' && (
              <div className={styles.field}>
                <label>Specify Type<span className={styles.required}>*</span></label>
                <input name="issueTypeOther" value={form.issueTypeOther} onChange={onChange} placeholder="Describe the type" />
              </div>
            )}
          </div>

          <div className={styles.field}>
            <label>Subject<span className={styles.required}>*</span></label>
            <input name="subject" value={form.subject} onChange={onChange} placeholder="Short summary" />
          </div>

          <div className={styles.field}>
            <label>Description<span className={styles.required}>*</span></label>
            <textarea name="description" value={form.description} onChange={onChange} rows={6} placeholder="Please include steps to reproduce, expected vs actual behavior, etc." />
          </div>

          <div className={styles.field}>
            <label>Screenshot</label>
            <input type="file" accept="image/*" onChange={onFileChange} />
            {screenshot && <div className={styles.fileInfo}>{screenshot.name}</div>}
          </div>

          <button className={styles.submit} type="submit" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit Issue'}</button>
        </form>
      </div>
      </div>
    </SidebarLayout>
  );
};

export default ReportIssuePage;



